/* src/app/pages/casos/paso1/paso1.component.scss */
/*# sourceMappingURL=paso1.component.css.map */
